import _hubQuery from "./__generated__/hubQuery.graphql";
import React, { Suspense } from 'react';
import { di } from 'react-magnetic-di';
import { graphql, usePreloadedQuery } from 'react-relay';
import { ReactRenderer } from '@atlaskit/renderer';
import { useRelayResource } from '@atlassian/company-hub-common';
import { HubAppShell } from '@atlassian/hub-app-shell';
import { hubResource } from '../../services/resources';
var Hub = function Hub(_ref) {
  var _data$helpCenter, _helpCenterData$homeP;
  var queryReference = _ref.queryReference;
  var data = usePreloadedQuery(_hubQuery, queryReference);
  var helpCenterData = (_data$helpCenter = data.helpCenter) === null || _data$helpCenter === void 0 ? void 0 : _data$helpCenter.helpCenterById;
  if ((helpCenterData === null || helpCenterData === void 0 ? void 0 : helpCenterData.__typename) === 'QueryError') {
    return /*#__PURE__*/React.createElement(HubAppShell, null, /*#__PURE__*/React.createElement("div", null, "Error: ", helpCenterData.message));
  }
  if ((helpCenterData === null || helpCenterData === void 0 ? void 0 : helpCenterData.__typename) !== 'HelpCenter') {
    return;
  }
  var layoutAdf = ((_helpCenterData$homeP = helpCenterData.homePageLayout) === null || _helpCenterData$homeP === void 0 || (_helpCenterData$homeP = _helpCenterData$homeP.layoutAdf) === null || _helpCenterData$homeP === void 0 || (_helpCenterData$homeP = _helpCenterData$homeP.content) === null || _helpCenterData$homeP === void 0 || (_helpCenterData$homeP = _helpCenterData$homeP.edges) === null || _helpCenterData$homeP === void 0 || (_helpCenterData$homeP = _helpCenterData$homeP.map(function (edge) {
    var _edge$node;
    return edge === null || edge === void 0 || (_edge$node = edge.node) === null || _edge$node === void 0 ? void 0 : _edge$node.content;
  })) === null || _helpCenterData$homeP === void 0 ? void 0 : _helpCenterData$homeP.join('')) || '{}';
  var parsedAdf = JSON.parse(layoutAdf);
  return /*#__PURE__*/React.createElement(HubAppShell, null, /*#__PURE__*/React.createElement(ReactRenderer, {
    document: parsedAdf,
    appearance: "full-page"
  }));
};
export var HubApp = function HubApp() {
  var _useRelayResource = useRelayResource(hubResource),
    queryReference = _useRelayResource.queryReference;
  if (!queryReference) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement("div", null, "Loading...")
  }, /*#__PURE__*/React.createElement(Hub, {
    queryReference: queryReference
  }));
};